import { render, staticRenderFns } from "./BigCommerceDetails.vue?vue&type=template&id=2fec4f31&"
import script from "./BigCommerceDetails.vue?vue&type=script&lang=js&"
export * from "./BigCommerceDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports